import ReactApexChart from "react-apexcharts";
import { colorPalette, monthNames } from "./chartOption";
import { useTranslation } from "react-i18next";
const COSTS = 10;
interface CropCostsProps {
    residualMaterial: Map<string, number>;
}
const CropCosts = ({ residualMaterial }: CropCostsProps) => {
    const colors = colorPalette.slice(
        0,
        Array.from(residualMaterial.keys()).length
    );
    const { t } = useTranslation(["sensor"]);

    const chartData = {
        series: [
            {
                name: t("sesnor.chart.cost"),
                data: Array.from(residualMaterial.values()).map(
                    (rasidual) => Number(rasidual) * COSTS
                ),
            },
        ],
        options: {
            chart: {
                zoom: {
                    enabled: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            colors,

            grid: {
                row: {
                    opacity: 0.5,
                },
            },
            xaxis: {
                categories: monthNames,
            },
            title: {
                text: 'Harvest costs'
              },
        },
    };

    return (
        <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="line"
            height={300}
        />
    );
};

export default CropCosts;
